export default __webpack_public_path__ + "static/media/telephone.7512f53e.png";